import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-modal';
import Loader from '../components/Loader';
import UpstriveHome from '../successEnvelope.png';
import UpstriveSuccess from '../SuccessEmailValidation.png';
import UpstriveInvalid from '../ExpiredEmailValidation.png';
import { verifyAccount } from '../server/server';
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		backgroundColor: '#F2F6FF',
		borderRadius: '20px',
		width: 350,
		padding: '20px',
		borderWidth: 0,
		boxShadow: '0px 11px 16px 0px rgba(32, 212, 191, 0.2)',
		overflow: 'visible',
	},
	overlay: {
		// backgroundColor: '#F2F6FF4D',
		backgroundColor: '#F2F6FF1A',
		backdropFilter: 'blur(2px)',
	},
};
function ValidateAccountModal({ modalIsOpen, email, token }) {
	const [loading, setLoading] = useState(true);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState('');

	const image = useMemo(() => {
		if (loading) return UpstriveHome;
		else if (success) return UpstriveSuccess;
		return UpstriveInvalid;
	}, [success, loading]);

	const openModal = async () => {
		const data = { email: email, token };
		const resp = await verifyAccount(data);
		if (resp.status == 201) {
			setSuccess(true);
		} else {
			setError(resp.data.message);
			setSuccess(false);
		}
		setLoading(false);
	};

	return (
		<Modal isOpen={modalIsOpen} style={customStyles} contentLabel='Validate account' shouldCloseOnEsc onAfterOpen={openModal} onRequestClose={() => setError(false)}>
			<div className='flex flex-col pb-[20px]'>
				<button className=' w-[40px] h-[40px] rounded-full bg-[#ECEDF5] -mt-[40px] self-center items-center justify-center'></button>
				<div className='mb-[20px] pt-[10px]'>
					<img src={image} alt='Success button' className='home-image' />
				</div>
				<div className='px-[20px] text-center flex flex-col gap-[15px] items-center'>
					<p className='text-[#02393E] font-bold text-[24px]'>Validating your account</p>
					{loading && <Loader />}
					{!loading && success && (
						<>
							<p className='text-[#02393E]'>You successfully confirmed your email</p>
						</>
					)}
					{!loading && !success && (
						<>
							<p className='text-[#02393E]'>{error}</p>
						</>
					)}
				</div>
			</div>
		</Modal>
	);
}

export default ValidateAccountModal;
